module.exports = __webpack_public_path__ + "img/hospitalGray.fd5fe136.svg";